import { Route } from '@angular/router';
import { SignInComponent } from './modules/auth/sign-in/sign-in.component';
import { AuthGuard } from './core/auth/guards/auth.guard';
import { RoleGuard } from './core/auth/guards/role.guard';
import { NoAuthGuard } from './core/auth/guards/noAuth.guard';
import { SignOutResolver } from './core/auth/sign-out.resolver';


export const appRoutes: Route[] = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'tenant/parking',
    },

    {
        path: 'sign-in',
        component: SignInComponent,
        canActivate: [NoAuthGuard],
    },

    {
        path: 'sign-out',
        canActivate: [AuthGuard],
        resolve: { action: SignOutResolver },
        children: [],
    },

    {
        path: 'redirect',
        canActivate: [RoleGuard],
        component: SignInComponent,
    },

    {
        path: 'dusbam',
        children: [
            {
                path: 'parking',
                children: [
                    {
                        path: 'tenant',
                        canActivate: [RoleGuard],
                        data: { roles: ['tenant'] },
                        loadChildren: () =>
                            import(
                                './modules/dusbam/parking/tenant/parking/parking.module'
                            ).then((m) => m.ParkingModule),
                    },
                    {

                        path: 'admin',
                        canActivate: [RoleGuard],
                        data: { roles: ['admin'] },
                        loadChildren: () =>
                            import(
                                './modules/dusbam/parking/admin/layouts/layouts.module'
                            ).then((m) => m.LayoutsModule),
                    },
                ],
            },
            {
                path: 'ticketing',
                children: [
                ],
            },
        ],
    },

    {
        path: 'tahura',
        children: [
            {
                path: 'parking',
                children: [
                    {
                        path: 'tenant',
                        canActivate: [RoleGuard],
                        data: { roles: ['tenant'] },
                        loadChildren: () =>
                            import(
                                './modules/tahura/parking/tenant/parking/parking.module'
                            ).then((m) => m.ParkingModule),
                    },
                    {
                        path: 'admin',
                        canActivate: [RoleGuard],
                        data: { roles: ['admin'] },
                        loadChildren: () =>
                            import(
                                './modules/tahura/parking/admin/layouts/layouts.module'
                            ).then((m) => m.LayoutsModule),
                    },
                ],
            },
            {
                path: 'ticketing',
                children: [
                    {
                        path: 'tenant',
                        canActivate: [RoleGuard],
                        data: { roles: ['tenant'] },
                        loadChildren: () =>
                            import(
                                './modules/tahura/ticketing/loket/loket.module'
                            ).then((m) => m.LoketModule),
                    },
                    {
                        path: 'admin',
                        canActivate: [RoleGuard],
                        data: { roles: ['admin'] },
                        loadChildren: () =>
                            import(
                                './modules/tahura/ticketing/admin/layouts/layouts.module'
                            ).then((m) => m.LayoutsModule),
                    },
                    {
                        path: 'loket',
                        // canActivate: [RoleGuard], 
                        // data: { roles: ['tenant'] }, 
                        loadChildren: () =>
                            import(
                                './modules/tahura/ticketing/loket/loket.module'
                            ).then((m) => m.LoketModule),
                    },
                ],
            },
        ],
    },
    
    // Fallback for default tenant (ticketing only)
    {
        path: ':tenant',
        children: [
            {
                path: 'ticketing',
                children: [
                    {
                        path: 'tenant',
                        canActivate: [RoleGuard],
                        data: { roles: ['tenant'] },
                        loadChildren: () =>
                            import(
                                './modules/default/ticketing/loket/loket.module'
                            ).then((m) => m.LoketModule),
                    },
                    {
                        path: 'admin',
                        canActivate: [RoleGuard],
                        data: { roles: ['admin'] },
                        loadChildren: () =>
                            import(
                                './modules/default/ticketing/admin/layouts/layouts.module'
                            ).then((m) => m.LayoutsModule),
                    },
                    {
                        path: 'loket',
                        loadChildren: () =>
                            import(
                                './modules/default/ticketing/loket/loket.module'
                            ).then((m) => m.LoketModule),
                    },
                ],
            },
        ],
    },

    {
        path: 'polrestacilacap',
        children: [
            {
                path: 'parking',
                children: [
                    {
                        path: 'tenant',
                        canActivate: [RoleGuard],
                        data: { roles: ['tenant'] },
                        loadChildren: () =>
                            import(
                                './modules/polrestacilacap/parking/tenant/parking/parking.module'
                            ).then((m) => m.ParkingModule),
                    },
                    {
                        path: 'admin',
                        canActivate: [RoleGuard],
                        data: { roles: ['admin'] },
                        loadChildren: () =>
                            import(
                                './modules/polrestacilacap/parking/admin/layouts/layouts.module'
                            ).then((m) => m.LayoutsModule),
                    },
                ],
            },
            {
                path: 'ticketing',
                children: [
                ],
            },
        ],
    },
    // Fallback 404
    {
        path: '**',
        redirectTo: 'sign-in',
    },
];
